import type {} from "@lit/react";
import { BreadcrumbsItem as BreadcrumbsItemElement, } from "@vaadin/breadcrumbs/vaadin-breadcrumbs-item.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { BreadcrumbsItemElement, };
export type BreadcrumbsItemEventMap = Readonly<{}>;
const events = {} as BreadcrumbsItemEventMap;
export type BreadcrumbsItemProps = WebComponentProps<BreadcrumbsItemElement, BreadcrumbsItemEventMap>;
export const BreadcrumbsItem = createComponent({
    elementClass: BreadcrumbsItemElement, events, react: React, tagName: "vaadin-breadcrumbs-item"
});
